import { useTeam } from "@repo/api";
import { InlineMessage, ListViewItem, Text, drillIcon } from "@repo/skapa";
import { t } from "@repo/translation";
import {
  ElementsContainer,
  LabelField,
  ModalSheet,
  SectionContainer,
  TwoColumnElementsContainer,
  translateServices,
  useSettings,
} from "@repo/ui";

export const EnabledServicesModal = ({
  setIsModalOpen,
  isOpen,
  selectedTeam,
}: {
  setIsModalOpen: (val: boolean) => void;
  isOpen: boolean;
  selectedTeam?: number;
}) => {
  const { boka_config } = useSettings();
  const { data: team } = useTeam(selectedTeam);
  const enabled = boka_config?.enable;
  const allEnabled = boka_config?.enable_all_stores_and_services;
  const storeConfig = boka_config?.stores?.find(
    (s) => s.unit_id_key === team?.buCode
  );

  return (
    <ModalSheet
      title={t("label.enabled_services")}
      visible={isOpen}
      onClose={() => setIsModalOpen(false)}
    >
      <SectionContainer>
        <InlineMessage
          title={t("label.note")}
          body={t("prompt.only_showing_enabled_services")}
          variant="informative"
        />
        {(!enabled || !storeConfig) && (
          <Text>{t("prompt.store_not_enabled")}</Text>
        )}
        {allEnabled && <Text>{t("prompt.all_stores_enabled")}</Text>}
        {storeConfig && (
          <>
            <TwoColumnElementsContainer>
              <LabelField
                id="enabled"
                editable={false}
                label="Enabled"
                value={storeConfig.enable ? t("label.yes") : t("label.no")}
              />
              <LabelField
                id="enabled"
                editable={false}
                label={t("label.zip_code")}
                value={storeConfig.zip_code}
              />
            </TwoColumnElementsContainer>

            <ElementsContainer>
              <Text textStyle="Heading.S">{t("label.services")}</Text>

              {storeConfig?.service_configs
                ?.map((s) => s.service_name_key)
                ?.map((el) => (
                  <ListViewItem
                    key={el}
                    leadingIcon={drillIcon}
                    title={translateServices(el)}
                    description={el}
                  />
                ))}
            </ElementsContainer>
          </>
        )}
      </SectionContainer>
    </ModalSheet>
  );
};
